import React from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { useState } from "react";
import {
  MapPin,
  Clock3,
  CalendarCheck,
  Activity,
  Navigation,
  BriefcaseBusiness,
  Coffee,
  CheckCircle2,
  Monitor,
  Route,
  ChevronDown,
  Users,
  Timer,
  MapPinned,
  CircleDot,
  CalendarDays,
  LocateFixed,
} from "lucide-react";



const employees = [
  {
    id: 1,
    name: "Rahul Sharma",
    role: "Frontend Developer",
    initials: "RS",
    color: "#dc2626",
    status: "Active",
    location: "NernexSoft Office, Kolkata",
    checkIn: "09:32 AM",
    workHours: "05h 12m",
    distance: "2.4 km",
    progress: 65,
    lat: "22.5726° N",
    lng: "88.3639° E",
    activities: [
      { time: "09:32 AM", title: "Checked in", detail: "Started work at office", type: "success" },
      { time: "10:15 AM", title: "Work session started", detail: "Working on dashboard UI", type: "work" },
      { time: "11:40 AM", title: "Team meeting", detail: "Frontend sprint discussion", type: "meeting" },
      { time: "12:20 PM", title: "Active work session", detail: "Working on assigned tasks", type: "work" },
    ],
  },
  {
    id: 2,
    name: "Priya Das",
    role: "UI/UX Designer",
    initials: "PD",
    color: "#be123c",
    status: "On Break",
    location: "Sector V, Salt Lake",
    checkIn: "09:15 AM",
    workHours: "04h 48m",
    distance: "1.8 km",
    progress: 58,
    lat: "22.5697° N",
    lng: "88.4320° E",
    activities: [
      { time: "09:15 AM", title: "Checked in", detail: "Started work remotely", type: "success" },
      { time: "10:00 AM", title: "Design work started", detail: "Website redesign project", type: "work" },
      { time: "11:45 AM", title: "Client review", detail: "Reviewed design feedback", type: "meeting" },
      { time: "12:30 PM", title: "Break started", detail: "Taking a short break", type: "break" },
    ],
  },
  {
    id: 3,
    name: "Amit Roy",
    role: "Backend Developer",
    initials: "AR",
    color: "#991b1b",
    status: "Offline",
    location: "Last recorded: Office",
    checkIn: "10:05 AM",
    workHours: "03h 35m",
    distance: "0 km",
    progress: 42,
    lat: "22.5726° N",
    lng: "88.3639° E",
    activities: [
      { time: "10:05 AM", title: "Checked in", detail: "Started work at office", type: "success" },
      { time: "10:30 AM", title: "Development started", detail: "API development task", type: "work" },
      { time: "11:50 AM", title: "Code review", detail: "Reviewed pending changes", type: "meeting" },
      { time: "12:10 PM", title: "Last active", detail: "Last recorded activity", type: "break" },
    ],
  },
  {
    id: 4,
    name: "Sneha Paul",
    role: "Project Manager",
    initials: "SP",
    color: "#b91c1c",
    status: "Active",
    location: "Client Site, Salt Lake",
    checkIn: "09:00 AM",
    workHours: "05h 40m",
    distance: "4.6 km",
    progress: 72,
    lat: "22.5800° N",
    lng: "88.4200° E",
    activities: [
      { time: "09:00 AM", title: "Checked in", detail: "Started the workday", type: "success" },
      { time: "09:45 AM", title: "Client visit", detail: "Project status discussion", type: "meeting" },
      { time: "11:15 AM", title: "Team coordination", detail: "Reviewed team deliverables", type: "work" },
      { time: "12:00 PM", title: "Active work session", detail: "Updating project timeline", type: "work" },
    ],
  },
];

const statusStyles = {
  Active: { bg: "#f0fdf4", color: "#15803d", dot: "#16a34a" },
  "On Break": { bg: "#fff7ed", color: "#c2410c", dot: "#ea580c" },
  Offline: { bg: "#f5f5f5", color: "#525252", dot: "#737373" },
};


const EmployeeTracking = () => {
      const [selectedId, setSelectedId] = useState(1);
  const [activityFilter, setActivityFilter] = useState("All");

  const employee = employees.find((e) => e.id === selectedId);
  const status = statusStyles[employee.status];

  const filteredActivities = employee.activities.filter((a) => {
    if (activityFilter === "All") return true;
    if (activityFilter === "Work") return a.type === "work";
    if (activityFilter === "Meetings") return a.type === "meeting";
    return a.type === "break";
  });

    const styles = {
    page: {
      width: "100%",
      boxSizing: "border-box",
      background: "#ffffff",
      color: "#111111",
      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    },
    card: {
      background: "#ffffff",
      border: "1px solid #e5b4b4",
      borderRadius: 13,
      padding: 20,
      minWidth: 0,
      boxSizing: "border-box",
    },
    heading: {
      fontSize: 15,
      fontWeight: 700,
      margin: 0,
      color: "#111111",
    },
    muted: {
      fontSize: 12,
      color: "#737373",
    },
    label: {
      fontSize: 11,
      color: "#525252",
      fontWeight: 700,
      letterSpacing: ".5px",
      textTransform: "uppercase",
    },
  };

   const activityIcon = (type) => {
    if (type === "success") return <CheckCircle2 size={17} color="#16a34a" />;
    if (type === "meeting") return <BriefcaseBusiness size={17} color="#dc2626" />;
    if (type === "break") return <Coffee size={17} color="#737373" />;
    return <Monitor size={17} color="#dc2626" />;
  };


  return (
    <div id="main_content">
          <Header/>
            <div className="page">
                  <Section/>
                    <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">EmployeeRoles</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    EmployeeRoles
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
         
        <div className="section-body mt-4">
               <div style={styles.page}>
      <style>{`
        .et-grid {
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(280px, 1fr);
          gap: 18px;
        }

        .et-stats {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 12px;
        }

        .et-stat {
          padding: 17px;
          border: 1px solid #e5b4b4;
          border-radius: 12px;
          background: #ffffff;
          min-width: 0;
          box-sizing: border-box;
        }

        .et-employee-select {
          width: 100%;
          padding: 12px 38px 12px 13px;
          border: 1px solid #dc2626;
          border-radius: 9px;
          background: #ffffff;
          color: #111111;
          font-size: 13px;
          outline: none;
          appearance: none;
          cursor: pointer;
        }

        .et-employee-select:focus {
          border-color: #b91c1c;
          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
        }

        .et-map {
          position: relative;
          height: 285px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
          border-radius: 10px;
          background: #f7f7f7;
        }

        .et-filter {
          border: 1px solid #e5e5e5;
          background: #ffffff;
          border-radius: 7px;
          padding: 7px 10px;
          cursor: pointer;
          font-size: 11px;
          color: #262626;
          white-space: nowrap;
          transition: .2s;
        }

        .et-filter.active {
          background: #dc2626;
          border-color: #dc2626;
          color: #ffffff;
          font-weight: 700;
        }

        .et-timeline-row {
          display: flex;
          gap: 12px;
          position: relative;
          padding-bottom: 23px;
        }

        .et-timeline-row:not(:last-child):before {
          content: "";
          position: absolute;
          left: 8px;
          top: 23px;
          bottom: 0;
          border-left: 1px dashed #e5b4b4;
        }

        .et-timeline-row:last-child {
          padding-bottom: 0;
        }

        .et-avatar {
          width: 43px;
          height: 43px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 13px;
          flex-shrink: 0;
        }

        .et-progress {
          width: 100%;
          height: 6px;
          background: #f3f3f3;
          border-radius: 10px;
          overflow: hidden;
        }

        .et-progress-fill {
          height: 100%;
          background: #dc2626;
          border-radius: 10px;
          transition: width .3s ease;
        }

        .et-action {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          gap: 7px;
          padding: 9px 12px;
          background: #ffffff;
          border: 1px solid #dc2626;
          border-radius: 8px;
          color: #b91c1c;
          font-size: 11px;
          font-weight: 600;
        }

        @media (max-width: 1000px) {
          .et-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 650px) {
          .et-stats {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 10px;
          }

          .et-stat {
            padding: 13px;
          }

          .et-card {
            padding: 15px !important;
          }

          .et-map {
            height: 235px;
          }

          .et-top {
            align-items: flex-start !important;
            flex-direction: column;
          }

          .et-employee-header {
            align-items: flex-start !important;
            flex-direction: column;
          }

          .et-employee-info {
            width: 100%;
          }
        }
      `}</style>

      {/* Page heading */}
      <div
        className="et-top"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 16,
          marginBottom: 22,
          flexWrap: "wrap",
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                background: "#fff1f1",
                border: "1px solid #fecaca",
                padding: 9,
                borderRadius: 10,
                display: "flex",
              }}
            >
              <LocateFixed size={22} color="#dc2626" />
            </div>
            <h2 style={{ fontSize: 23, margin: 0, fontWeight: 750, letterSpacing: "-.5px" }}>
              Employee Tracking
            </h2>
          </div>
          <p style={{ margin: "8px 0 0", color: "#737373", fontSize: 13 }}>
            Monitor employee attendance, locations and daily activities.
          </p>
        </div>

        <div style={{ display: "flex", gap: 9, alignItems: "center", flexWrap: "wrap" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 12px",
              border: "1px solid #e5b4b4",
              borderRadius: 9,
              background: "#ffffff",
              fontSize: 12,
              color: "#111111",
            }}
          >
            <CalendarDays size={15} color="#dc2626" />
            28 Oct 2026
          </div>
          <span
            style={{
              border: "1px solid #fecaca",
              color: "#b91c1c",
              background: "#fff7f7",
              padding: "7px 10px",
              borderRadius: 7,
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: ".5px",
            }}
          >
            DEMO DATA
          </span>
        </div>
      </div>

      {/* Employee selector */}
      <div
        className="et-card"
        style={{
          ...styles.card,
          marginBottom: 17,
        }}
      >
        <div
          className="et-employee-header"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 22,
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: "1 1 245px", minWidth: 0 }}>
            <div style={{ ...styles.label, marginBottom: 9 }}>
              Select employee
            </div>
            <div style={{ position: "relative" }}>
              <select
                className="et-employee-select"
                value={selectedId}
                onChange={(e) => {
                  setSelectedId(Number(e.target.value));
                  setActivityFilter("All");
                }}
              >
                {employees.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.name} — {e.role}
                  </option>
                ))}
              </select>
              <ChevronDown
                size={16}
                style={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#dc2626",
                }}
              />
            </div>
          </div>

          <div
            className="et-employee-info"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              flex: "1 1 260px",
              minWidth: 0,
            }}
          >
            <div
              className="et-avatar"
              style={{
                background: employee.color,
                width: 49,
                height: 49,
                borderRadius: 12,
              }}
            >
              {employee.initials}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 750, color: "#111111" }}>
                {employee.name}
              </div>
              <div style={{ fontSize: 12, color: "#737373", marginTop: 5 }}>
                {employee.role}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 5,
                  alignItems: "center",
                  fontSize: 11,
                  color: "#525252",
                  marginTop: 6,
                }}
              >
                <MapPin size={12} color="#dc2626" />
                {employee.location}
              </div>
            </div>

            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "7px 10px",
                borderRadius: 20,
                background: status.bg,
                color: status.color,
                fontSize: 11,
                fontWeight: 700,
                whiteSpace: "nowrap",
                border: `1px solid ${status.dot}35`,
              }}
            >
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: status.dot,
                }}
              />
              {employee.status}
            </span>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="et-stats" style={{ marginBottom: 18 }}>
        {[
          {
            label: "Work Duration",
            value: employee.workHours,
            sub: "Recorded today",
            icon: Clock3,
          },
          {
            label: "Check-in Time",
            value: employee.checkIn,
            sub: "First attendance entry",
            icon: CalendarCheck,
          },
          {
            label: "Distance Travelled",
            value: employee.distance,
            sub: "Recorded distance (demo)",
            icon: Route,
          },
          {
            label: "Daily Progress",
            value: `${employee.progress}%`,
            sub: "Estimated workday progress",
            icon: Activity,
          },
        ].map((stat) => {
          const Icon = stat.icon;

          return (
            <div className="et-stat" key={stat.label}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 5,
                  marginBottom: 16,
                }}
              >
                <span
                  style={{
                    ...styles.label,
                    fontSize: 10,
                    letterSpacing: ".25px",
                  }}
                >
                  {stat.label}
                </span>

                <span
                  style={{
                    padding: 8,
                    borderRadius: 9,
                    background: "#fff1f1",
                    border: "1px solid #fee2e2",
                    display: "flex",
                    flexShrink: 0,
                  }}
                >
                  <Icon size={17} color="#dc2626" />
                </span>
              </div>

              <div
                style={{
                  fontSize: 23,
                  fontWeight: 750,
                  letterSpacing: "-.5px",
                  color: "#111111",
                  overflowWrap: "anywhere",
                }}
              >
                {stat.value}
              </div>

              <div
                style={{
                  color: "#737373",
                  fontSize: 10,
                  marginTop: 8,
                  lineHeight: 1.5,
                }}
              >
                {stat.sub}
              </div>

              {stat.label === "Daily Progress" && (
                <div className="et-progress" style={{ marginTop: 12 }}>
                  <div
                    className="et-progress-fill"
                    style={{ width: `${employee.progress}%` }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Map and timeline */}
      <div className="et-grid">
        {/* Location panel */}
        
<div className="et-card" style={styles.card}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 10,
      marginBottom: 18,
      flexWrap: "wrap",
    }}
  >
    <div>
      <h3 style={styles.heading}>Location Overview</h3>
      <p style={{ ...styles.muted, margin: "6px 0 0" }}>
        Employee location and movement overview
      </p>
    </div>

    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: "#fff1f1",
        color: "#b91c1c",
        border: "1px solid #fecaca",
        padding: "6px 9px",
        borderRadius: 7,
        fontSize: 10,
        fontWeight: 600,
      }}
    >
      <MapPin size={12} />
      Static preview
    </span>
  </div>

  {/* Decorative static map */}
  <div className="et-map">
    <svg
      viewBox="0 0 640 360"
      preserveAspectRatio="xMidYMid slice"
      style={{
        width: "100%",
        height: "100%",
        display: "block",
      }}
    >
      <rect width="640" height="360" fill="#f5f5f5" />

      {/* City blocks */}
      <g fill="#ffffff" stroke="#e5e5e5" strokeWidth="1">
        <rect x="20" y="20" width="100" height="65" rx="4" />
        <rect x="145" y="20" width="80" height="95" rx="4" />
        <rect x="250" y="20" width="130" height="55" rx="4" />
        <rect x="410" y="20" width="90" height="90" rx="4" />
        <rect x="530" y="20" width="90" height="70" rx="4" />
        <rect x="20" y="130" width="75" height="90" rx="4" />
        <rect x="120" y="145" width="110" height="75" rx="4" />
        <rect x="270" y="105" width="90" height="80" rx="4" />
        <rect x="395" y="135" width="115" height="75" rx="4" />
        <rect x="535" y="120" width="85" height="95" rx="4" />
        <rect x="20" y="250" width="120" height="80" rx="4" />
        <rect x="165" y="250" width="85" height="80" rx="4" />
        <rect x="280" y="240" width="110" height="90" rx="4" />
        <rect x="420" y="250" width="85" height="80" rx="4" />
        <rect x="530" y="245" width="90" height="85" rx="4" />
      </g>

      {/* Roads */}
      <g
        fill="none"
        stroke="#ffffff"
        strokeWidth="17"
        strokeLinecap="round"
      >
        <path d="M-10 115 L660 225" />
        <path d="M245 -20 L350 390" />
        <path d="M500 -20 L420 390" />
        <path d="M-10 240 L660 105" />
      </g>

      <g
        fill="none"
        stroke="#e7a4a4"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <path d="M-10 115 L660 225" />
        <path d="M245 -20 L350 390" />
      </g>

      {/* Labels */}
      <g
        fill="#737373"
        fontSize="11"
        fontFamily="Arial, sans-serif"
      >
        <text x="30" y="45">Business Park</text>
        <text x="410" y="48">Office Zone</text>
        <text x="35" y="285">Residential Area</text>
        <text x="425" y="285">Main Road</text>
      </g>

      {/* Previous tracking route */}
      <g
        fill="none"
        stroke="#dc2626"
        strokeWidth="2.5"
        strokeDasharray="7 6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M55 115 L115 150 L180 125 L225 185 L280 220 L320 175" />
      </g>

      {/* Previous location points */}
      {[
        { x: 55, y: 115, time: "09:00 AM" },
        { x: 115, y: 150, time: "09:30 AM" },
        { x: 180, y: 125, time: "10:00 AM" },
        { x: 225, y: 185, time: "10:30 AM" },
        { x: 280, y: 220, time: "11:00 AM" },
      ].map((point, index) => (
        <g key={index}>
          <circle
            cx={point.x}
            cy={point.y}
            r="12"
            fill="#ffffff"
            stroke="#2563eb"
            strokeWidth="2"
          />
          <circle
            cx={point.x}
            cy={point.y}
            r="6"
            fill="#2563eb"
          />
          <title>{`Previous location - ${point.time}`}</title>
        </g>
      ))}

      {/* Current location marker */}
      <circle
        cx="320"
        cy="175"
        r="31"
        fill="#dc2626"
        opacity=".10"
      />
      <circle
        cx="320"
        cy="175"
        r="20"
        fill="#dc2626"
        opacity=".15"
      />
      <circle
        cx="320"
        cy="175"
        r="11"
        fill="#dc2626"
        stroke="#ffffff"
        strokeWidth="4"
      />

      {/* Current location label */}
      <g transform="translate(345 127)">
        <rect
          width="160"
          height="36"
          rx="7"
          fill="#ffffff"
          stroke="#fecaca"
        />
        <text
          x="12"
          y="15"
          fontSize="10"
          fill="#b91c1c"
          fontWeight="700"
          fontFamily="Arial, sans-serif"
        >
          {employee.name}
        </text>
        <text
          x="12"
          y="27"
          fontSize="9"
          fill="#737373"
          fontFamily="Arial, sans-serif"
        >
          Last recorded location
        </text>
      </g>
    </svg>

    <div
      style={{
        position: "absolute",
        left: 12,
        bottom: 12,
        padding: "9px 11px",
        background: "#ffffff",
        border: "1px solid #e5b4b4",
        borderRadius: 8,
        fontSize: 10,
        color: "#262626",
        boxShadow: "0 2px 8px #00000008",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <MapPin size={13} color="#dc2626" />
        <span style={{ fontWeight: 700 }}>Employee position</span>
      </div>
      <div style={{ marginTop: 5, color: "#737373" }}>
        {employee.lat} / {employee.lng}
      </div>
    </div>

    {/* Map location control */}
    <div
      style={{
        position: "absolute",
        right: 12,
        bottom: 12,
        width: 34,
        height: 34,
        background: "#ffffff",
        border: "1px solid #e5b4b4",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LocateFixed size={17} color="#dc2626" />
    </div>
  </div>

  {/* Location details */}
  <div
    style={{
      marginTop: 16,
      padding: 14,
      background: "#ffffff",
      border: "1px solid #e5b4b4",
      borderRadius: 10,
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
    }}
  >
    <div
      style={{
        padding: 9,
        borderRadius: 9,
        background: "#fff1f1",
        display: "flex",
      }}
    >
      <MapPinned size={18} color="#dc2626" />
    </div>

    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "#111111" }}>
        {employee.location}
      </div>
      <div
        style={{
          fontSize: 11,
          color: "#737373",
          marginTop: 5,
          lineHeight: 1.6,
        }}
      >
        Latitude: {employee.lat}
        <br />
        Longitude: {employee.lng}
      </div>
    </div>

    <span
      style={{
        color: "#b91c1c",
        fontSize: 10,
        background: "#fff1f1",
        padding: "5px 7px",
        borderRadius: 6,
        whiteSpace: "nowrap",
      }}
    >
      Demo GPS
    </span>
  </div>

  {/* Work progress */}
  <div
    style={{
      marginTop: 18,
      paddingTop: 17,
      borderTop: "1px solid #f1d4d4",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 10,
        marginBottom: 10,
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 700 }}>
        Daily work progress
      </span>
      <span style={{ fontSize: 12, color: "#b91c1c", fontWeight: 700 }}>
        {employee.progress}%
      </span>
    </div>

    <div className="et-progress" style={{ height: 7 }}>
      <div
        className="et-progress-fill"
        style={{ width: `${employee.progress}%` }}
      />
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        color: "#737373",
        fontSize: 10,
        marginTop: 8,
      }}
    >
      <span>09:00 AM</span>
      <span>06:00 PM</span>
    </div>
  </div>
</div>


        {/* Activity timeline */}
        <div className="et-card" style={styles.card}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 10,
              marginBottom: 17,
            }}
          >
            <div>
              <h3 style={styles.heading}>Activity Timeline</h3>
              <p style={{ ...styles.muted, margin: "6px 0 0" }}>
                Daily employee activity log
              </p>
            </div>
            <div
              style={{
                padding: 8,
                borderRadius: 9,
                background: "#fff1f1",
                border: "1px solid #fecaca",
                display: "flex",
              }}
            >
              <Activity size={17} color="#dc2626" />
            </div>
          </div>

          {/* Filters */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              paddingBottom: 15,
              borderBottom: "1px solid #f1d4d4",
              marginBottom: 20,
            }}
          >
            {["All", "Work", "Meetings", "Breaks"].map((filter) => (
              <button
                type="button"
                key={filter}
                className={`et-filter ${activityFilter === filter ? "active" : ""}`}
                onClick={() => setActivityFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Timeline entries */}
          {filteredActivities.length > 0 ? (
            <div>
              {filteredActivities.map((item, index) => (
                <div className="et-timeline-row" key={`${item.time}-${item.title}`}>
                  <div
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 9,
                      background: item.type === "success" ? "#f0fdf4" : "#fff5f5",
                      border: `1px solid ${item.type === "success" ? "#bbf7d0" : "#fecaca"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      zIndex: 1,
                    }}
                  >
                    {activityIcon(item.type)}
                  </div>

                  <div style={{ flex: 1, minWidth: 0, paddingTop: 2 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "#111111",
                        }}
                      >
                        {item.title}
                      </span>
                      <span
                        style={{
                          fontSize: 10,
                          color: "#737373",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.time}
                      </span>
                    </div>

                    <p
                      style={{
                        fontSize: 11,
                        color: "#737373",
                        margin: "6px 0 0",
                        lineHeight: 1.5,
                      }}
                    >
                      {item.detail}
                    </p>

                    <div
                      style={{
                        fontSize: 9,
                        marginTop: 8,
                        color: item.type === "success" ? "#15803d" : "#b91c1c",
                        background: item.type === "success" ? "#f0fdf4" : "#fff5f5",
                        border: `1px solid ${item.type === "success" ? "#bbf7d0" : "#fecaca"}`,
                        padding: "4px 7px",
                        borderRadius: 5,
                        display: "inline-block",
                      }}
                    >
                      {item.type === "success"
                        ? "ATTENDANCE"
                        : item.type === "meeting"
                        ? "MEETING"
                        : item.type === "break"
                        ? "BREAK"
                        : "WORK SESSION"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                padding: "35px 10px",
                textAlign: "center",
                color: "#737373",
                fontSize: 12,
              }}
            >
              No activities found for this filter.
            </div>
          )}

          {/* Summary footer */}
          <div
            style={{
              marginTop: 22,
              padding: 14,
              background: "#fffafa",
              border: "1px solid #e5b4b4",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <Timer size={16} color="#dc2626" />
              <span style={{ fontSize: 12, fontWeight: 700 }}>
                Today's summary
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                fontSize: 11,
                color: "#525252",
              }}
            >
              <span>Total recorded work</span>
              <span style={{ fontWeight: 700, color: "#111111" }}>
                {employee.workHours}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                fontSize: 11,
                color: "#525252",
                marginTop: 10,
              }}
            >
              <span>Recorded activities</span>
              <span style={{ fontWeight: 700, color: "#111111" }}>
                {employee.activities.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Employee list */}
      <div className="et-card" style={{ ...styles.card, marginTop: 18 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
            marginBottom: 17,
          }}
        >
          <div>
            <h3 style={styles.heading}>Team Overview</h3>
            <p style={{ ...styles.muted, margin: "6px 0 0" }}>
              Select an employee to view their tracking details.
            </p>
          </div>

          <span
            style={{
              fontSize: 11,
              color: "#b91c1c",
              background: "#fff1f1",
              border: "1px solid #fecaca",
              padding: "7px 10px",
              borderRadius: 7,
            }}
          >
            {employees.length} Employees
          </span>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(215px, 1fr))",
            gap: 12,
          }}
        >
          {employees.map((e) => {
            const employeeStatus = statusStyles[e.status];
            const isSelected = e.id === selectedId;

            return (
              <button
                type="button"
                key={e.id}
                onClick={() => {
                  setSelectedId(e.id);
                  setActivityFilter("All");
                }}
                style={{
                  textAlign: "left",
                  background: "#ffffff",
                  border: isSelected ? "1px solid #dc2626" : "1px solid #e5b4b4",
                  boxShadow: isSelected ? "0 0 0 2px #dc262610" : "none",
                  borderRadius: 11,
                  padding: 14,
                  cursor: "pointer",
                  color: "#111111",
                  minWidth: 0,
                  fontFamily: "inherit",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <div
                    className="et-avatar"
                    style={{
                      background: e.color,
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    {e.initials}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {e.name}
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#737373",
                        marginTop: 4,
                      }}
                    >
                      {e.role}
                    </div>
                  </div>

                  {isSelected && <CheckCircle2 size={17} color="#dc2626" />}
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 13,
                    fontSize: 10,
                    color: employeeStatus.color,
                  }}
                >
                  <CircleDot size={12} color={employeeStatus.dot} />
                  {e.status}
                  <span style={{ marginLeft: "auto", color: "#737373" }}>
                    {e.workHours}
                  </span>
                </div>

                <div
                  style={{
                    height: 4,
                    borderRadius: 5,
                    background: "#f3f3f3",
                    overflow: "hidden",
                    marginTop: 11,
                  }}
                >
                  <div
                    style={{
                      width: `${e.progress}%`,
                      height: "100%",
                      background: "#dc2626",
                      borderRadius: 5,
                    }}
                  />
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <div
        style={{
          marginTop: 14,
          fontSize: 10,
          color: "#737373",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <Activity size={12} color="#dc2626" />
        This page uses static demo data. Employee coordinates, attendance,
        activity and work duration are not connected to a live tracking service.
      </div>
    </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                
              </div>
            </div>
          </footer>
        </div>
                  </div>
      
    </div>
  )
}

export default EmployeeTracking
